<template>
	<ul class="card-pagination">
		<li
			v-for="(item, index) in data"
			:key="'A' + index"
			class="dot-ind"
			:class="{ 'dot-selected': currentEl === index }"
		>
			<button
				class="indicator-btn"
				:name="item"
				:disabled="currentEl === index"
				:aria-hidden="currentEl === index"
				:aria-label="$t('goToCluster', { careerCluster: item.name })"
				@click="showEl(index)"
			/>
		</li>
	</ul>
</template>

<script>
export default {
	name: 'Indicators',
	props: {
		data: { type: Array, required: true },
		currentEl: { type: Number, default: 0 },
		showEl: { type: Function, required: true }
	}
};
</script>

<style lang="scss" scoped>
.card-pagination {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 32px;

	.dot-ind {
		width: 8px;
		height: 8px;
		border-radius: 50%;
		// margin: auto;
		margin-left: 8px;
		margin-right: 8px;
	}

	.indicator-btn {
		display: block;
		padding: 4px;
		background: #ccdbf6;
		border-radius: 100%;
		border: none;
		font-size: 0;
		&:hover {
			cursor: pointer;
		}
	}

	.dot-selected {
		width: 16px;
		height: 16px;

		.indicator-btn {
			padding: 8px;
			background-color: $selected-card-color;
		}
	}
}
</style>
